import { useMemo } from "react";

export function useClipPathId(name = "clip-path") {
  return useMemo(() => {
    return `${name}-${Math.random()
      .toString(36)
      .substring(2, 11)}`;
  }, [name]);
}
